import TarifasScreen from './TarifasScreen'

export default TarifasScreen
